export default "__VITE_ASSET__mMbnB_NE__"